import { Dispatch, SetStateAction } from 'react';
import { ValidationRule } from 'antd/lib/form/Form';
import { UploadResponse, UploadFile } from '@erecruit/ui-kit';
import { Intl } from '@erecruit/core';
import { Mutations } from '@erecruit/types';
import { SubmitProblemPayloadProps, ProblemReportModalForm } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const normalizeFile = (event: any) => {
  if (Array.isArray(event)) {
    return event;
  }
  return event && event.fileList;
};

export const getValidationRules = (intl: Intl.InjectedIntl) => {
  const maxFilesCount = 5;
  const maxAttachmentSize = 10;
  const rules: ValidationRule[] = [
    {
      type: 'array',
      max: maxFilesCount,
      message: intl.formatMessage(
        {
          id: messageIds.vms.reportProblem.maximumNumberOfFilesRule,
        },
        { maxFilesCount: maxFilesCount },
      ),
    },
    {
      validator: (_, value, callback) => {
        try {
          const files = value as UploadFile[];
          if (!files) return callback();
          const bytes = files.reduce((acc, file) => acc + file.size, 0);
          const kilobytes = bytes / 1024;
          const megabytes = kilobytes / 1024;
          if (megabytes >= maxAttachmentSize) {
            return new Error(
              intl.formatMessage(
                {
                  id: messageIds.vms.reportProblem.maximumSizeRule,
                },
                { maxAttachmentSize: maxAttachmentSize },
              ),
            );
          }
          callback();
        } catch (err) {
          callback(err);
        }
      },
    },
  ];
  return rules;
};

export const getSubmitProblemAttachments = (
  files: UploadFile<UploadResponse>[],
): Mutations.SubmitProblemAttachment[] =>
  files?.map(file => {
    const data: Mutations.SubmitProblemAttachment = {
      name: file.name,
      base64Data: (file.response as UploadResponse)?.data,
    };
    return data;
  });

export const getSubmitProblemData = (
  values: ProblemReportModalForm,
): SubmitProblemPayloadProps => ({
  description: values.description,
  subject: values.subject,
  attachments: getSubmitProblemAttachments(values.upload),
});

export const invalidateOkButton = (
  files: UploadFile[],
  setOkDisabled: Dispatch<SetStateAction<boolean>>,
) => {
  const uploadInProgressCount = files
    ?.map(file => (file.response as UploadResponse)?.data)
    .filter(data => data === undefined).length;

  uploadInProgressCount > 0 ? setOkDisabled(true) : setOkDisabled(false);
};
